<nav class="navbar navbar-light bg-light navbar-expand-lg">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
            <li class="nav-item me-2">
                <div class="nav-item">
                    <input id="busquedaFormControl" type="text" class="form-control" placeholder="Nombre interfaz"
                    [formControl]="buscadorFormControl" (input)="filtrarInterfaces()"/>
                </div>
            </li>
        </ul>
    </div>
</nav>
<div class="row">
    <div class="col col-3">
        <div class="list-group py-3 menu-izq">
            <app-interfaces-lista [interfaces]="interfacesFiltradas" (interfazSeleccionada)="mostrarInterfaz($event)"></app-interfaces-lista>
        </div>
    </div>
    <div class="col col-9 py-3">
        <app-interfaces-detalle *ngIf="interfazSeleccionada" [interfaz]="interfazSeleccionada"> </app-interfaces-detalle>
    </div>
</div>